import { FC, useEffect } from 'react'
import { Outlet } from 'react-router'
import { InteractionStatus } from '@azure/msal-browser'
import { useIsAuthenticated, useMsal } from '@azure/msal-react'
import { loginRequest } from '@/application/auth/config/msalConfig'
import { LoadingPage } from '@/pages/LoadingPage/LoadingPage'

// This component redirects to the login if the user is not authenticated
export const ProtectedRoute: FC = () => {
  const isAuthenticated = useIsAuthenticated()
  const { instance, inProgress } = useMsal()

  useEffect(() => {
    if (inProgress === InteractionStatus.None && !isAuthenticated) {
      instance.loginRedirect(loginRequest)
    }
  }, [isAuthenticated, inProgress, instance])

  if (inProgress !== InteractionStatus.None) {
    return <LoadingPage fullScreen />
  }

  if (!isAuthenticated) {
    return null
  }

  return <Outlet />
}
